import React from "react";
import {
  FaUserMd,
  FaShareAlt,
  FaMobileAlt,
} from "react-icons/fa";
import {
  FaGears,
  FaPeopleGroup,
  FaHandHoldingMedical
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import "./style.css";
import Navbar1 from "../../Elements/Navbar1/index.js";
import Footer from "../../Elements/Footer/index.js";
const Features = () => {
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 768; // Simple mobile detection

  const selectedCountry = localStorage.getItem("Location");
  const handlePricingClick = () => {
    navigate(`/pricing`);
  };

  return (
    <>
      <Navbar1 />
      <div className="features">
        <div className="features-content-wrapper">
          <div className="features-content-container">
            <div className="features-sub-header">
              <h4 className="features-header-text">
                {/* Securely store and access all your patient health records - anytime, anywhere from any device */}
                <span style={{color: "green"}} >on</span><span style={{ color: "#3058A6"}}>COCHARTS</span> uses our propreitary COCHART analytics engine to <br/> seamlessly integrate patient health records and clinical evidence and <br/> generate insights for clinicians and hospitals.
              </h4>
            </div>

            {/* <h2 className="features-key-heading">Key Features</h2> */}

            <div className="features-card">
              <div className="feature-item">
                <div className="feature-icon">
                  <FaPeopleGroup />
                </div>
                <h3 className="feature-title">Seamless Patient Onboarding</h3>
                <p className="feature-description">
                  Oncocharts helps you onboard your patients with cancer with ease using a simple and intuitive software interface. 
                  Managing patients health records, treatment plans, and follow-ups could not be easier.
                </p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <FaGears />
                </div>
                <h3 className="feature-title">Insights at the point of care</h3>
                <p className="feature-description">
                  Powered by AI, Oncocharts can extract information on key clinical parameters from patient health records. 
                  Customise the set of parameters you want to see and generate reports. 
                </p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <FaHandHoldingMedical />
                </div>
                <h3 className="feature-title">Enhanced Patient Engagement</h3>
                <p className="feature-description">
                  Analayse patient health records using oncology specific AI. Empower your pateints with personalised information and resources. 
            
                </p>
              </div>

              {/* <div className="feature-item">
                <div className="feature-icon">
                  <FaUserMd />
                </div>
                <h3 className="feature-title">Evidence-Based Clinical Decisions</h3>
                <p className="feature-description">
                Oncocharts facilitates integration of medical and scientific research information into your medical practice.
                Stay ahead with the latest in oncology science and practice guidelines and make informed decisions.
                </p>
              </div> */}

              {/* <div className="feature-item">
                <div className="feature-icon">
                  <FaShareAlt />
                </div>
                <h3 className="feature-title">Healthcare Collaboration Tools</h3>
                <p className="feature-description">
                  Oncocharts software provides cloud-based advanced collaboration tools.
                  Securely save, download, and share critical information with other healthcare professionals in a few clicks.
                </p>
              </div> */}

              {/* <div className="feature-item">
                <div className="feature-icon">
                  <FaMobileAlt />
                </div>
                <h3 className="feature-title">Mobile App with Assistive AI</h3>
                <p className="feature-description">
                  Leverage the power of Oncocharts AI on your mobile app as
                  your 24/7 AI assistant to help you with patient care on the go.
                </p>
              </div> */}

            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Features;
